import { createIcon } from '../createIcon';

export const FileArrowUpIconConfig = {
  name: 'FileArrowUpIcon',
  height: 512,
  width: 384,
  svgPath: 'M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z',
  yOffset: 0,
  xOffset: 0
};

export const FileArrowUpIcon = createIcon(FileArrowUpIconConfig);

export default FileArrowUpIcon;